module.exports = __webpack_public_path__ + "img/p1.5ca4a9d2.png";